module.exports = __webpack_public_path__ + "img/back.08551bf2.jpg";